import { Controller } from "@hotwired/stimulus";

// Manages selectable rows for Programs and Schedules in Plan Access.
// Simple row click-to-toggle with clean selected states.
export default class extends Controller {
  static targets = ["row"];

  connect() {
    this.syncRowStates();
    this.boundSync = () => this.syncRowStates();
    document.addEventListener("plan-access:selectionsCleared", this.boundSync);
  }

  disconnect() {
    document.removeEventListener("plan-access:selectionsCleared", this.boundSync);
  }

  syncRowStates() {
    this.rowTargets.forEach((row) => {
      const checkbox = row.querySelector('input[type="checkbox"]');
      this.toggleRowState(row, checkbox?.checked ?? false);
    });
  }

  rowClick(event) {
    if (event.target.closest("a, button")) return;
    const row = event.currentTarget;
    const checkbox = row.querySelector('input[type="checkbox"]');
    if (!checkbox) return;
    checkbox.checked = !checkbox.checked;
    this.toggleRowState(row, checkbox.checked);
  }

  toggleRowState(row, selected) {
    row.classList.toggle("bg-primary-50/60", selected);
    row.classList.toggle("dark:bg-primary-900/15", selected);
    row.classList.toggle("border-l-primary-500", selected);
    const check = row.querySelector("[data-check-indicator]");
    if (check) {
      check.classList.toggle("opacity-0", !selected);
      check.classList.toggle("invisible", !selected);
    }
  }
}
